var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Model, Watch } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import { Teacher } from '@/models/Teacher';
import DataTable from '@/components/data-table/DataTable';
import { Group } from '@/models/Group';
import { GroupType, GroupTypeEnum } from '@/models/GroupType';
import { avatarHtml, sanitizeString } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';
import { User } from '@/models/User';
import AddUserDialog from '@/views/Groups/AddUserDialog';
import SelectFilter from '@/components/select-filter/SelectFilter';
import AddSubjectDialog from '@/components/AddSubjectDialog/AddSubjectDialog';
import { Curriculum } from '@/models/Curriculum';
import { blackKidIcons, blackAreaIcons } from '@/support/Icon';
import Storage from '@/support/Storage';
import Notes from '@/views/Users/Student/Notes';
import TreatmentDialog from '@/views/Curricula/TreatmentDialog';
import AbstractUrl from '@/support/AbstractUrl';
import { RolesEnum } from '@/items/Roles';
import AddSkillsetDialog from '@/components/add-skillset-dialog/AddSkillsetDialog.vue';
import client from '@/support/Client';
import ResetUsersPasswordDialog from '@/components/ResetUsersPasswordDialog/ResetUsersPasswordDialog';
import { GroupIncludes, Model as BaseModel } from '@/models/Model';
import LoaderCard from '@/components/loader-card/LoaderCard';
let Profile = class Profile extends AbstractUrl {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Group';
        this.users = [];
        this.selectedStudents = [];
        this.selectedTeachers = [];
        this.selectedUser = null;
        this.bulkDeleteType = '';
        this.isEditing = false;
        this.isEditingGroupsCard = false;
        this.isAddingSubjects = false;
        this.isEditingTreatment = false;
        this.selectedStudentId = '';
        this.isAddingUser = false;
        this.isDeletingUser = false;
        this.isDeletingMultipleTeachers = false;
        this.isDeletingMultipleStudents = false;
        this.clearSelectedStudent = false;
        this.clearSelectedTeacher = false;
        this.userDialogType = '';
        this.isShowingSingleUserNotes = false;
        this.selectedRoom = null;
        this.curriculum = new Curriculum();
        this.editableGroup = null;
        this.selectedUserText = '';
        this.selectedProject = '';
        this.subjectMeta = {};
        this.clearSelectedSubGroups = false;
        this.selectedSubGroup = null;
        this.selectedSubGroups = [];
        this.isShowingSkillDialog = false;
        this.isShowingResetPasswordDialog = false;
        this.isDeleteSubGroupDialogOpen = false;
        this.isAddingSubGroupDialogOpen = false;
        this.isUpdatingSubGroups = false;
        this.isLoading = true;
        this.groupTypes = [];
        this.treatmentHtml = (treatment_labels) => {
            if (!this.$store.state.Auth.hasRole([
                RolesEnum.TEACHER,
                RolesEnum.ROOT,
                RolesEnum.ADMIN,
                RolesEnum.TRAINER,
                RolesEnum.MANAGER,
            ])) {
                return '';
            }
            let html = '<div class="student-treatment no-whitespace student-treatment__container">';
            if (treatment_labels && treatment_labels.length) {
                html += '<span class="editTreatment">';
                treatment_labels.forEach((item, index) => {
                    html += `<div class="treatment__example treatment__example--${item.key}"></div>`;
                });
                html += '</span>';
            }
            if (!treatment_labels || !treatment_labels.length) {
                html += `<span class="editTreatment editTreatment--label">${this.$tc('profile.add_support')}</span>`;
            }
            html += '</div>';
            return html;
        };
    }
    get groupModel() {
        return new Group({ id: this.$route.params.id }).include([
            GroupIncludes.AUDIT,
            GroupIncludes.CHAT,
            GroupIncludes.USERS,
            GroupIncludes.SUBJECTS,
            GroupIncludes.ROLES,
            GroupIncludes.PARENT,
            GroupIncludes.NOTES,
            GroupIncludes.PROJECTS,
            GroupIncludes.TYPE,
            GroupIncludes.SUB_GROUPS,
        ]);
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        await this.fetchGroupTypes();
        this.users = [];
        this.getAreas(this.group);
        this.editableGroup = this.group.clone();
        if (this.editableGroup && this.editableGroup.type) {
            this.editableGroup.type = new BaseModel().dataToModel(this.editableGroup.type, 'GroupType');
        }
    }
    get isParnasysGroup() {
        return !!(this.group &&
            this.group.type &&
            typeof this.group.type !== 'string' &&
            this.group.type.label === GroupTypeEnum.PARNASSYS);
    }
    get blackIcons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? blackAreaIcons : blackKidIcons;
    }
    get tableTeacherOptions() {
        return {
            name: {
                singular: this.$tc('roles.teacher', 1),
                plural: this.$tc('roles.teacher', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                { text: this.$t('name.title'), value: 'name' },
            ],
            actions: this.$store.state.Auth.hasRole([
                RolesEnum.TEACHER,
                RolesEnum.ADMIN,
                RolesEnum.TRAINER,
                RolesEnum.MANAGER,
                RolesEnum.ROOT,
            ])
                ? [
                    {
                        type: 'delete',
                        label: 'delete',
                        icon: 'delete',
                        action: (vm, user) => {
                            this.selectedUser = user;
                            this.selectedUserText = this.$t('dialogOptions.item.teacher').toString();
                            this.$store.dispatch('openDialog', this.deleteSingleUserDialogOptions);
                        },
                    },
                ]
                : [],
            dropdown: this.canSeeTeacherDropDown
                ? [
                    {
                        text: this.$tc('actions.delete', 1) + ' ' + this.$tc('roles.teacher', 2),
                        icon: 'delete',
                        action: () => {
                            this.bulkDeleteType = 'teacher';
                            this.isDeletingMultipleTeachers = true;
                        },
                    },
                ]
                : [],
            filters: [],
            model: new Teacher().filter('group', this.group ? this.group.id : null),
        };
    }
    get tableStudentOptions() {
        return {
            name: {
                singular: this.$tc('roles.student', 1),
                plural: this.$tc('roles.student', 2),
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    action: (student) => {
                        if (this.$store.state.Auth.id && !this.$store.state.Auth.hasRole([RolesEnum.STUDENT])) {
                            const route = this.$router.resolve(`/groups/${this.group.id}/students/${student.id}/school-tracker`);
                            window.open(route.href, '_blank');
                        }
                    },
                    class: 'cursorPointer',
                },
                {
                    text: '',
                    value: 'treatment_labels',
                    action: (student) => {
                        this.openTreatmentDialog(`${student.id}`);
                    },
                    transform: this.treatmentHtml,
                    class: 'cursorPointer',
                },
            ],
            actions: this.$store.state.Auth.hasRole([
                RolesEnum.TEACHER,
                RolesEnum.ADMIN,
                RolesEnum.ROOT,
                RolesEnum.TRAINER,
                RolesEnum.MANAGER,
            ])
                ? [
                    {
                        type: 'view',
                        label: 'view',
                        icon: 'notes',
                        action: (vm, user) => {
                            this.selectedUser = user;
                            this.isShowingSingleUserNotes = true;
                        },
                    },
                    {
                        type: 'delete',
                        label: 'delete',
                        icon: 'delete',
                        action: (vm, user) => {
                            this.selectedUser = user;
                            this.selectedUserText = this.$t('dialogOptions.item.student').toString();
                            this.$store.dispatch('openDialog', this.deleteSingleUserDialogOptions);
                        },
                    },
                ]
                : [],
            dropdown: this.canSeeStudentDropDown
                ? [
                    {
                        text: this.$tc('actions.delete', 1) + ' ' + this.$tc('roles.student', 2),
                        icon: 'delete',
                        action: () => {
                            this.bulkDeleteType = 'student';
                            this.isDeletingMultipleStudents = true;
                        },
                    },
                ]
                : [],
            filters: [],
            model: new Student()
                .include(['treatment_labels', 'treatment'])
                .filter({ group: this.group ? this.group.id : null })
                .limit(10),
        };
    }
    get canSeeStudentDropDown() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.TEACHER,
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.ROOT,
        ]);
    }
    get canSeeTeacherDropDown() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.TEACHER,
            RolesEnum.ADMIN,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.ROOT,
        ]);
    }
    get deleteSingleUserDialogOptions() {
        const user = this.selectedUser;
        return {
            title: user.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.deleteFromGroup', 2, {
                item: this.selectedUserText,
            }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!this.editableGroup || !this.selectedUser) {
                            return;
                        }
                        const users = [];
                        this.editableGroup.users
                            .filter((user) => user.id !== this.selectedUser.id)
                            .forEach((user) => {
                            if (user.id) {
                                users.push(user.id);
                            }
                        });
                        this.editableGroup
                            .include(['audit', 'chat', 'users', 'subjects', 'roles', 'parent', 'type'])
                            .update({
                            name: this.editableGroup.name,
                            users,
                        })
                            .then((group) => {
                            this.editableGroup = group.clone();
                            this.users = [];
                            if (!this.editableGroup) {
                                return;
                            }
                            this.editableGroup.users.forEach((user) => {
                                if (user.id) {
                                    this.users.push(user.id);
                                }
                            });
                            this.selectedUser = new User();
                            this.$emit('update', group);
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedUser = new User();
                    },
                },
            },
        };
    }
    get deleteSubGroupsOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('profile.group') })
                .toString()
                .toLowerCase(),
            type: 'error',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: async () => {
                        if (!this.selectedSubGroup) {
                            return;
                        }
                        this.isUpdatingSubGroups = true;
                        const response = await this.deleteSubGroup(this.selectedSubGroup);
                        if (response) {
                            this.handleUpdate(response);
                            this.selectedSubGroup = null;
                        }
                        this.isUpdatingSubGroups = false;
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedSubGroup = null;
                    },
                },
            },
        };
    }
    get dialogOptionsStudents() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, {
                item: this.$t('dialogOptions.item.user'),
            }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!this.editableGroup) {
                            return;
                        }
                        const selected = this.selectedStudents.map((student) => {
                            return student.id;
                        });
                        const filteredUsers = this.group.users
                            .map((user) => {
                            return user.id || '';
                        })
                            .filter((id) => {
                            return !selected.includes(id);
                        });
                        this.editableGroup
                            .include(['audit', 'chat', 'users', 'subjects', 'roles', 'parent', 'type'])
                            .update({
                            users: filteredUsers,
                        })
                            .then((group) => {
                            this.editableGroup = group.clone();
                            this.users = [];
                            if (!this.editableGroup) {
                                return;
                            }
                            this.editableGroup.users.forEach((user) => {
                                if (user.id) {
                                    this.selectedStudents = [];
                                    this.clearSelectedStudent = true;
                                    this.users.push(user.id);
                                }
                            });
                            this.$emit('update', group);
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedUser = new User();
                    },
                },
            },
        };
    }
    get dialogOptionsTeachers() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, {
                item: this.$t('dialogOptions.item.user'),
            }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!this.editableGroup) {
                            return;
                        }
                        const selected = this.selectedTeachers.map((teacher) => {
                            return teacher.id;
                        });
                        const filteredUsers = this.group.users
                            .map((user) => {
                            return user.id || '';
                        })
                            .filter((id) => {
                            return !selected.includes(id);
                        });
                        this.group
                            .include(['audit', 'chat', 'users', 'subjects', 'roles', 'parent', 'type'])
                            .update({
                            users: filteredUsers,
                        })
                            .then((group) => {
                            this.editableGroup = group.clone();
                            this.users = [];
                            if (!this.editableGroup) {
                                return;
                            }
                            this.editableGroup.users.forEach((user) => {
                                if (user.id) {
                                    this.selectedTeachers = [];
                                    this.clearSelectedTeacher = true;
                                    this.users.push(user.id);
                                }
                            });
                            this.$emit('update', group);
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedUser = new User();
                    },
                },
            },
        };
    }
    get canNavitageToProjectSubject() {
        return (this.$store.state.Auth &&
            this.$store.state.Auth.roles &&
            this.$store.state.Auth.roles.some((role) => role.id === RolesEnum.STUDENT));
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.TEACHER,
        ]);
    }
    get user() {
        return this.$store.state.Auth;
    }
    async fetchGroupTypes() {
        try {
            this.isLoading = true;
            const types = await new GroupType().all();
            this.groupTypes = types.map((groupType) => {
                let translated = groupType.name;
                if (!translated) {
                    translated = Object.values(GroupTypeEnum).includes(groupType.label)
                        ? String(this.$t(`group.types.${groupType.label}`))
                        : groupType.label;
                }
                return {
                    ...groupType,
                    translated,
                };
            });
        }
        finally {
            this.isLoading = false;
        }
    }
    async deleteSubGroup(subGroup) {
        if (!(this.group.sub_groups && this.group.sub_groups.length)) {
            return null;
        }
        const payload = { sub_groups: [] };
        if (typeof this.group.sub_groups[0] === 'string') {
            payload.sub_groups = this.group.sub_groups.filter((group) => group !== subGroup.id);
        }
        else {
            payload.sub_groups = this.group.sub_groups
                .filter((group) => group.id !== subGroup.id)
                .map((group) => group.id);
        }
        return this.groupModel.update(payload).catch(() => []);
    }
    async addSubGroups(subGroup) {
        const payload = { sub_groups: [] };
        if (this.group.sub_groups && this.group.sub_groups.length) {
            if (typeof this.group.sub_groups[0] === 'string') {
                payload.sub_groups = this.group.sub_groups;
            }
            else {
                payload.sub_groups = this.group.sub_groups.map((group) => group.id);
            }
        }
        subGroup.forEach((group) => {
            payload.sub_groups.push(group.id);
        });
        return this.groupModel.update(payload).catch(() => []);
    }
    get subGroupTableOptions() {
        const exclude = [this.$route.params.id];
        if (this.group.sub_groups && this.group.sub_groups.length) {
            this.group.sub_groups.forEach((subGroup) => exclude.push(typeof subGroup === 'string' ? subGroup : subGroup.id));
        }
        return {
            name: {
                singular: 'Group',
                plural: 'Groups',
            },
            headers: [
                { text: this.$t('name.title'), value: 'name' },
                {
                    text: this.$tc('group.type'),
                    value: 'type',
                    transform: (type, group) => type.name,
                },
            ],
            actions: [],
            filters: [],
            model: new Group()
                .include([GroupIncludes.TYPE])
                .filter({ without_parent_groups: true, exclude }),
        };
    }
    onAddSkillCategory(category) {
        this.addSkillCategory(category);
    }
    async onUpdatePassword(user) {
        await user;
        this.isShowingResetPasswordDialog = false;
    }
    async addSkillCategory(category) {
        try {
            let students = this.selectedStudents;
            if (!students || !students.length) {
                students = await new Student()
                    .include(['treatment_labels', 'treatment'])
                    .filter({ group: this.group ? this.group.id : null })
                    .limit(100)
                    .all();
            }
            await client('post', 'portfolios/skills/to-group-from-category', {
                category: category.id,
                users: students.map((user) => user.id),
            });
            this.$store.dispatch('openDialog', this.addSkillSetSuccess);
        }
        catch (error) {
            //
        }
    }
    onDeleteSubgroup(group) {
        this.selectedSubGroup = group;
        this.isDeleteSubGroupDialogOpen = true;
    }
    async onAddSubGroups() {
        this.isUpdatingSubGroups = true;
        this.isAddingSubGroupDialogOpen = false;
        const response = await this.addSubGroups(this.selectedSubGroups);
        if (response) {
            this.handleUpdate(response);
            this.selectedSubGroups = [];
        }
        this.isUpdatingSubGroups = false;
    }
    onClickResetPassword() {
        // Open dialog here
        this.isShowingResetPasswordDialog = true;
    }
    update() {
        if (!this.editableGroup) {
            return;
        }
        this.isEditing = false;
        // console.log('this.editableGroup.type',this.editableGroup.type);
        const payload = {
            users: this.users,
            name: this.editableGroup.name,
            type: this.editableGroup.type.id,
            is_visible_for_students: this.editableGroup.is_visible_for_students,
        };
        this.editableGroup.users = this.users;
        if (this.selectedRoom) {
            payload.room = this.selectedRoom;
        }
        // console.log('this.selectedProject', this.selectedProject);
        if (this.editableGroup.projects) {
            payload.projects = this.editableGroup.projects.map((project) => project.id);
        }
        else {
            payload.projects = [];
        }
        this.editableGroup
            .include(['audit', 'chat', 'users', 'subjects', 'roles', 'parent', 'projects', 'type'])
            .update(payload)
            .then((group) => {
            this.editableGroup = group.clone();
            this.$emit('update', group);
        })
            .catch((error) => ErrorHandler.network(error));
    }
    getGroupName(type) {
        const currentType = this.groupTypes.find((item) => {
            return item.type === type;
        });
        if (currentType) {
            return currentType.name;
        }
        return '';
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    studentDropdown() {
        return this.tableStudentOptions.dropdown;
    }
    teacherDropdown() {
        return this.tableTeacherOptions.dropdown;
    }
    onClickNavigateToSubjects() {
        if (this.group.projects && this.group.projects.length > 0) {
            this.$router.push(`/my-projects`);
        }
        // console.log('TODO MIKE navigate to my subject as studen met filter project aan')
    }
    deleteSubject(deletedSubject) {
        if (!this.editableGroup || !this.editableGroup.subjects) {
            return;
        }
        const filteredSubjects = this.editableGroup.subjects
            .map((subject) => {
            return subject.id || '';
        })
            .filter((id) => {
            return id !== deletedSubject.id;
        });
        const payload = {
            subjects: filteredSubjects,
        };
        this.editableGroup
            .include(['audit', 'chat', 'users', 'subjects', 'roles', 'parent', 'type'])
            .update(payload)
            .then((group) => {
            this.editableGroup = group.clone();
            this.handleUpdate(this.editableGroup);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    handleUpdate(group) {
        this.getAreas(group);
        this.$emit('update', group);
    }
    async updateSubjects(selectedSubjects) {
        if (!this.group.subjects) {
            return;
        }
        const existingSubjects = [];
        this.group.subjects.map((subject) => {
            existingSubjects.push(subject.id);
        });
        const internalSelectedSubjects = [];
        selectedSubjects.forEach((subject) => {
            selectedSubjects.push(subject.id);
        });
        const subjects = [...existingSubjects, ...internalSelectedSubjects];
        try {
            await new Group({ id: this.group.id })
                .include(['audit', 'chat', 'users', 'subjects', 'roles', 'parent', 'type'])
                .update({
                subjects,
            });
            this.handleUpdate(this.group);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    handleTreatmentSaved() {
        this.$emit('treatmentSaved');
        this.isEditingTreatment = false;
    }
    getAreas(group) {
        if (!group.subjects) {
            return;
        }
        const curriculum = this.$store.state.curriculum;
        group.subjects.map((subject) => {
            if (!subject.parent) {
                return;
            }
            const topicId = subject.parent.id;
            curriculum.subjects.map((area) => {
                if (!area.children) {
                    return;
                }
                const topics = area.children.find((topic) => topic.id === topicId);
                if (!topics) {
                    return;
                }
                this.subjectMeta[subject.id] = {
                    name: area.name,
                    color: area.color,
                    icon: area.icon,
                };
            });
        });
    }
    resetGroup() {
        if (!this.editableGroup) {
            return;
        }
        this.editableGroup = this.group.clone();
    }
    openTreatmentDialog(studentId) {
        this.selectedStudentId = studentId;
        this.isEditingTreatment = true;
    }
    handleUserAdded(group) {
        this.refreshDataTable();
        this.$emit('update', group);
    }
    sanitizeString(value) {
        return sanitizeString(value);
    }
    getGroupLabel() {
        if (!this.group || !this.group.type) {
            return '-';
        }
        const groupType = this.group.type;
        let translated = groupType.name;
        if (!translated) {
            translated = Object.values(GroupTypeEnum).includes(groupType.label)
                ? String(this.$t(`group.types.${groupType.label}`))
                : groupType.label;
        }
        return translated;
    }
    get addSkillSetSuccess() {
        return {
            title: 'Vaardighedenset succesvol toegevoegd',
            text: 'De geselecteerde vaardighedenset is succesvol toegevoegd aan de geselecteerde leerlingen',
            type: 'success',
            buttons: {
                confirm: {
                    text: 'Sluiten',
                },
            },
        };
    }
    groupChanged() {
        this.editableGroup = this.group;
        this.initialize();
    }
};
__decorate([
    Model('group', { default: () => new Group() }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], Profile.prototype, "group", void 0);
__decorate([
    Watch('group'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Profile.prototype, "groupChanged", null);
Profile = __decorate([
    Component({
        components: {
            LoaderCard,
            DataTable,
            AddUserDialog,
            AddSubjectDialog,
            SelectFilter,
            Notes,
            TreatmentDialog,
            AddSkillsetDialog,
            ResetUsersPasswordDialog,
        },
    })
], Profile);
export default Profile;
class ExtendedGroupType extends GroupType {
}
